import React, {useEffect, useState} from 'react';
import Frame from "../common/Frame";
import {appdata} from "../../logic_tmp/appdata/AppData";
import {useHistory} from "react-router-dom";
import {useTranslation} from "react-i18next";
import './Price.css';
import {MotivationBlock} from "../common/MotivationBlock";
import {EventData} from "../common/EventData";
import {registerConcersion} from "../../logic/funel/FacebookUtils";
import {pingApi} from "../../backend/connectors/JavaConnector";
import {calculatePricesAndCounts} from "../../logic/setup/PriceCalculator";
import {PackagesBlock} from "./PackagesBlock";
import {SpecialProposal} from "../common/SpecialProposal";


export function Price() {
    pingApi().then()
    window.gtag('event', 'conversion', {'send_to': 'AW-457108933/EG_ICLjbpMAYEMXb-9kB'});
    const [counter, setCounter] = useState(0);
    const [updated, setUpdated] = useState(false);

    const handlePricesUpdate = () => {
        setUpdated(!updated) // П
    };

    const forceRender = () => {
        setCounter(counter + 1);
    };
    useEffect(() => {
        registerConcersion('AddToWishlist');
        if (appdata.utm_medium !== undefined && appdata.utm_medium.includes("KEY456"))
            registerConcersion('Purchase');

    }, []);
    const {t} = useTranslation();
    const history = useHistory();

    const handleSubmit = (e) => {
        e.preventDefault();
        if ("OFFLINE" === appdata.product.type)
            history.push("/amt");
        else {
            history.push("/lead");

        }
    }
    const handleCouponChange = (e) => {
        if (couponConfig["couponKey"] === e.target.value.trim().toUpperCase())
        {
            appdata.spKeyRedim = couponConfig["spKey"]
            calculatePricesAndCounts(appdata, appdata.product)
            forceRender()
        }
    }

    pingApi().then(r => {
    })
    let fullTicketHeader = "Ticket"
    let buyButtonText = "BuyTickets"
    if (appdata.product["productData"] !== undefined )
    {
        fullTicketHeader = t(appdata.product["productData"]["productNameKey"])
        buyButtonText = t(appdata.product["productData"]["buyButtonNameKey"])
    }


    let couponConfig = appdata.product["couponConfig"]
    let specialProposalConfig
        if (appdata.spKeyRedim)
            specialProposalConfig = appdata.product["specialProposalConfig"][appdata.spKeyRedim]
    appdata.header = undefined
    if (appdata.priceReduced > 0) {
        fullTicketHeader = "fullTicketDescription";
    }
    return (
        <div id="pricePage">
            <Frame>
                <EventData/>
                <h2 className="offer-pay__title bigfont">
                    {appdata.errorMessageKey !== undefined?
                        <div className="redfont">
                            {t(appdata.errorMessageKey)}
                        </div>:<div></div>
                    }
                    {appdata.spKeyRedim !== undefined?
                        <div className="redfont">
                            {t(specialProposalConfig["messageKey"])}
                       </div>:<div></div>}
                    <table>
                        <tbody>

                        {(couponConfig && appdata.spKeyRedim === undefined)?
                            <tr>
                                <td className="col2"> {t(couponConfig["promptKeyLabel"])}</td>
                                <td><input
                                    autoFocus
                                    name="price"
                                    onChange={event => {handleCouponChange(event)}}
                                    style={{width: 120, fontSize: 16}}
                                    placeholder={t(couponConfig["promptKeyPlaceholder"])}
                                    id="coupon"/></td>
                            </tr>:<tr></tr>
                        }
                        <tr>
                            <td className="col2">{appdata.priceFull}{appdata.product["currency"]}</td>
                            <td> - {t(fullTicketHeader)}</td>
                        </tr>
                        {(appdata.priceReduced !== 0) ?
                            <tr>
                                <td className="col2">{appdata.priceReduced}{appdata.product["currency"]}</td>
                                <td> - {t("reducedTicketDescription")}</td>
                            </tr> : <tr></tr>}
                        </tbody>
                    </table>
                </h2>
                {(appdata.discountTill !== undefined) ?
                    <h2 className="offer-pay__title red bigfont">
                        <div
                            className="offer-pay__title red bigfont">{t("ThisPricesAreValidTill", {date: appdata.discountTillMessage})}</div>
                    </h2> : <div></div>}

                <div>
                    <form className="app-form" method="post" id="lead_form" onSubmit={(e) => handleSubmit(e)}>
                        <div className="app-button d-flex justify-content-around">
                            <button id="nextButtonPrice" type="submit"
                                    className="app-btn app-btn-further next-step-btn">
                                <span>{t(buyButtonText)}</span>
                            </button>
                        </div>
                    </form>
                </div>
                <SpecialProposal onPricesUpdate={handlePricesUpdate} ></SpecialProposal>
                <MotivationBlock></MotivationBlock>
                <PackagesBlock/>
            </Frame>
        </div>
    );
}
